import MModal from '../m-modal/MModal';
import Error from '@img/Error.png';
import { useDispatch, useSelector } from 'react-redux';
import { setIsError, setIsErrorAfter401 } from '@reducers/notificationSlice.js';
import { useTranslation } from 'react-i18next';
import { memo, useEffect } from 'react';

const MModalError = () => {
    const dispatch = useDispatch();
    const isOpen = useSelector(state => state.notification.isError);
    const isAfter401 = useSelector(state => state.notification.isErrorAfter401);
    const text = useSelector(state => state.notification.errorText);
    const { t } = useTranslation();

    useEffect(() => {
        if (isAfter401 && isOpen) {
            dispatch(setIsError(false));
            dispatch(setIsErrorAfter401(false));
        }
    }, [dispatch, isAfter401, isOpen]);

    return (
      <MModal
        active={isOpen}
        setActive={() => dispatch(setIsError(''))}
        onCloseModal={() => {
        }}
        isNotification={true}
      >
          <div className={'w-[372px] flex flex-col items-center gap-[24px] justify-center'}>
              <img alt={'error'} src={Error} className={'w-fit'}/>
              <p className={'w-[260px] text-center'}>
                  {text}
              </p>
              <div>
                  <button
                    className={'btn-primary'}
                    onClick={() => dispatch(setIsError(''))}
                  >
                      {t('general.modals.NotificationsModals.close')}
                  </button>
              </div>
          </div>
      </MModal>
    );
};

export default memo(MModalError);
